import "core-js/modules/es.array.reverse.js";
var _class, _descriptor;
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, isObservableArray, makeObservable, observable } from "mobx";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import RuntimeError from "terriajs-cesium/Source/Core/RuntimeError";
import Result from "../../Core/Result";
import TerriaError from "../../Core/TerriaError";
import LocationSearchProviderMixin from "../../ModelMixins/SearchProviders/LocationSearchProviderMixin";
import { SearchBarTraits } from "../../Traits/SearchProviders/SearchBarTraits";
import CommonStrata from "../Definition/CommonStrata";
import CreateModel from "../Definition/CreateModel";
import updateModelFromJson from "../Definition/updateModelFromJson";
import SearchProviderFactory from "./SearchProviderFactory";
import upsertSearchProviderFromJson from "./upsertSearchProviderFromJson";
export let SearchBarModel = (_class = class SearchBarModel extends CreateModel(SearchBarTraits) {
  constructor(terria) {
    super("search-bar-model", terria);
    this.terria = terria;
    _defineProperty(this, "locationSearchProviders", observable.map());
    _initializerDefineProperty(this, "catalogSearchProvider", _descriptor, this);
    makeObservable(this);
  }
  updateModelConfig(config) {
    if (config) {
      updateModelFromJson(this, CommonStrata.definition, config);
    }
    return this;
  }
  initializeSearchProviders(searchProviders) {
    const errors = [];
    if (!isObservableArray(searchProviders)) {
      errors.push(new TerriaError({
        sender: SearchProviderFactory,
        title: "SearchProviders",
        message: {
          key: "searchProvider.noSearchProviders"
        }
      }));
    }
    searchProviders === null || searchProviders === void 0 || searchProviders.forEach(searchProvider => {
      const loadedModel = upsertSearchProviderFromJson(SearchProviderFactory, this.terria, CommonStrata.definition, searchProvider).pushErrorTo(errors);
      if (LocationSearchProviderMixin.isMixedInto(loadedModel)) {
        loadedModel.showWarning();
      }
    });
    return new Result(undefined, TerriaError.combine(errors, "An error occurred while loading search providers"));
  }

  /**
   * Add new SearchProvider to the list of SearchProviders.
   */
  addSearchProvider(model) {
    if (model.uniqueId === undefined) {
      throw new DeveloperError("A SearchProvider without a `uniqueId` cannot be added.");
    }
    if (this.locationSearchProviders.has(model.uniqueId)) {
      throw new RuntimeError("A SearchProvider with the specified ID already exists.");
    }
    if (!LocationSearchProviderMixin.isMixedInto(model)) {
      throw new RuntimeError("SearchProvider must be a LocationSearchProvider.");
    }
    this.locationSearchProviders.set(model.uniqueId, model);
  }
  get locationSearchProvidersArray() {
    return [...this.locationSearchProviders.entries()].filter(entry => {
      return LocationSearchProviderMixin.isMixedInto(entry[1]);
    }).map(function (entry) {
      return entry[1];
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "catalogSearchProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addSearchProvider", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addSearchProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchProvidersArray", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchProvidersArray"), _class.prototype), _class);